import { create } from 'zustand';

/**
 * Lightweight store to open/close the IncomeExpense modal from anywhere.
 * Call openModal({ name, type, amount, category, referenceId, isDue,
 * customerId, customerName, customerPhone, customerAddress }) to pre-fill.
 */
export const useIncomeExpenseStore = create((set) => ({
    isOpen: false,
    prefill: null, // { name, type, amount, category, referenceId, isDue, customerId, customerName, customerPhone, customerAddress }
    centered: false, // true = render as centered modal (shortcut when button hidden)

    openModal:   (prefill = null) => set({ isOpen: true, prefill }),
    closeModal:  () => set({ isOpen: false, prefill: null, centered: false }),
    toggleModal: () => set((s) => ({ isOpen: !s.isOpen, prefill: s.isOpen ? null : s.prefill, centered: s.isOpen ? false : s.centered })),
    openCentered: () => set({ isOpen: true, prefill: null, centered: true }),
}));
